import React from "react";
import styled from "styled-components";

const Tos = () => (
  <Contents>
    <div>
        <h2>Allgemeine Geschäftsbedingungen</h2>
        <h2>1. Einleitung</h2>
        <p>
          Willkommen bei Jurek Barth ("Firma", "wir", "uns", "unseres",
          "Anbieter"). Du hast gerade auf unsere allgemeinen
          Geschäftsbedingungen geklickt. Bitte lese diese Allgemeinen
          Geschäftsbedingungen daher aufmerksam durch.
        </p>
        <h2>2. Inhalte</h2>
        <p>
          Mit unserem Service kannst du bestimmte Informationen, Texte,
          Grafiken, Videos oder anderes Material ("Inhalt") veröffentlichen,
          verknüpfen, speichern, teilen und anderweitig verfügbar machen. Du
          bist für diese Inhalte verantwortlich, einschließlich deren
          Rechtmäßigkeit, Zuverlässigkeit und Angemessenheit.
        </p>
        <h2>3. Teilnahmevoraussetzungen</h2>
        <p>Die Nutzung unserer Services erfolgt auf eigenes Risiko.</p>
        <h2>4. Registrierung</h2>
        <p>
          4.1. Die Nutzung unserer Services setzt die Einrichtung eines
          Nutzerkontos voraus. Hierfür ist es erforderlich, dass der Nutzer
          persönliche Daten wie beispielsweise Email eingibt. Die Eröffnung
          eines Nutzerkontos ist über unsere mobilen Apps möglich. Die
          Registrierung kann alternativ auch mittels eines Drittanbieters
          (Apple) erfolgen. Einzelne für die Registrierung erforderliche Daten
          des Nutzers werden dann aus dem Konto des Drittanbieters übertragen.
          Der Nutzer wird bei der Registrierung von dem Anbieter aufgefordert,
          die Allgemeinen Geschäftsbedingungen und die Datenschutzbestimmungen
          zu akzeptieren. Nach erfolgter Anmeldung, übersendet der Anbieter dem
          Nutzer eine E-Mail, in der er ihn darum bittet, die Anmeldung durch
          Klicken auf den Button "E-Mail bestätigen" zu verifizieren oder den
          Code in der Email dafür zu verwenden. Nach bestätigen der Email, wird
          der Nutzer in die App oder auf die Webseite weitergeleitet, wo der
          Anbieter die Anmeldung final bestätigt. Erst danach ist der
          Anmeldeprozess abgeschlossen.
        </p>
        <p>
          4.2. Mit Akzeptanz dieser AGB, erlaubt der Nutzer dem Anbieter, ihm
          Informations- und Werbe-E-Mails passend zum Produkt an die angegebene
          E-Mail Adresse zu senden. Der Nutzer hat mit jedem Erhalt der
          Informations- und Werbe-E-Mails die Möglichkeit, sich von
          Informations- und Werbe-E-Mails abzumelden oder dem Erhalt zu
          widersprechen. Ab dem Zeitpunkt der Abmeldung beziehungsweise nach
          Bearbeitung des Widerspruchs erhält der Nutzer keine Informations- und
          Werbe-E-Mails mehr.
        </p>
        <h2>5. Verfügbarkeit und Haftung</h2>
        <p>
          5.1. Der Anbieter bietet seine Leistungen nach Art und Umfang auf der
          Grundlage der aktuellen technischen, rechtlichen und kommerziellen
          Rahmenbedingungen des Internets an. Der Anbieter ist bemüht, den
          Online Zugang zu den Produkten 24 Stunden täglich und an 7 Tagen pro
          Woche zur Verfügung zu stellen. Allerdings wird keine Haftung für die
          ständige Verfügbarkeit übernommen.
        </p>
        <p>
          5.2 Auch im Übrigen sind Ansprüche des Nutzers auf Schadensersatz
          ausgeschlossen. Hiervon ausgenommen sind Schadensersatzansprüche des
          Nutzers aus der Verletzung des Lebens, des Körpers, der Gesundheit
          oder aus der Verletzung wesentlicher Vertragspflichten
          (Kardinalpflichten) sowie die Haftung für sonstige Schäden, die auf
          einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung des
          Anbieters, seiner gesetzlichen Vertreter oder Erfüllungsgehilfen
          beruhen. Wesentliche Vertragspflichten sind solche, deren Erfüllung
          zur Erreichung des Ziels des Vertrags notwendig ist.
        </p>
        <p>
          5.3. Bei der Verletzung wesentlicher Vertragspflichten haftet der
          Anbieter nur auf den vertragstypischen, vorhersehbaren Schaden, wenn
          dieser einfach fahrlässig verursacht wurde, es sei denn, es handelt
          sich um Schadensersatzansprüche des Nutzers aus einer Verletzung des
          Lebens, des Körpers oder der Gesundheit.
        </p>
        <p>
          5.4. Die Einschränkungen der Ziffern 5.2. und 5.3. gelten auch
          zugunsten der gesetzlichen Vertreter und Erfüllungsgehilfen des
          Anbieters, wenn Ansprüche direkt gegen diese geltend gemacht werden.
        </p>
        <p>
          5.5. Die Vorschriften des Produkthaftungsgesetzes bleiben unberührt.
        </p>
        <h2>6. Änderungen der AGB</h2>
        <p>6.1. Der Anbieter ist jederzeit berechtigt diese AGB zu ändern.</p>
        <p>
          6.2. Im Falle einer Änderung der AGB wird der Anbieter den Nutzer
          hierüber in Textform in Kenntnis setzen. Die Zustimmung des Nutzers zu
          den entsprechenden Vertragsänderungen gilt dabei als erteilt, sofern
          der Nutzer der Änderung der AGB nicht binnen zwei (2) Wochen nach
          Zugang der Änderungsmitteilung in Textform widerspricht. Der Anbieter
          wird den Nutzer zusammen mit der Änderungsmitteilung nochmals
          ausdrücklich auf diese Folge eines unterlassenen Widerspruchs
          hinweisen.
        </p>
        <p>
          6.3. Für den Fall, dass der Nutzer seine Zustimmung zu den Änderungen
          der AGB mit Wirkung auf ein bestehendes Vertragsverhältnis verweigert,
          ist der Anbieter berechtigt, den Vertrag – unter Fortsetzung zu den
          bisherigen Bedingungen – zum Ablauf der unter Berücksichtigung des
          nächstmöglichen Kündigungszeitpunktes aktuellen Vertragslaufzeit zu
          kündigen. Eine erneute Teilnahme an den Leistungen wird dem Nutzer
          anschließend nur noch zu den jeweils aktuellen AGB angeboten.
        </p>
        <h2>7. Schlussbestimmungen</h2>
        <p>
          7.1. Sollten einzelne Bestimmungen dieser Allgemeinen
          Geschäftsbedingungen ganz oder in Teilen unwirksam sein oder werden,
          bleibt die Gültigkeit der übrigen Bestimmungen davon unberührt.
        </p>
        <p>
          7.2. Es findet das Recht der Bundesrepublik Deutschland unter
          Ausschluss der Vorschriften des UN-Kaufrechts (CISC) Anwendung. Im
          Geschäftsverkehr mit Verbrauchern innerhalb der Europäischen Union
          kann auch das Recht am Wohnsitz des Verbrauchers anwendbar sein,
          sofern es sich um zwingend anzuwendende verbraucherrechtliche
          Bestimmungen handelt.
        </p>
        <p>
          7.3. Sollte der Nutzer keinen allgemeinen Gerichtsstand in Deutschland
          oder in einem anderen EU-Mitgliedsstaat haben, Kaufmann sein oder
          seinen festen Wohnsitz nach Wirksamwerden dieser AGB ins Ausland
          verlegen oder sein Wohnsitz oder gewöhnlicher Aufenthaltsort im
          Zeitpunkt der Klageerhebung nicht bekannt sein, ist ausschließlicher
          Gerichtsstand der Geschäftssitz des Anbieters.
        </p>
      </div>
  </Contents>
);

const Contents = styled.div`
  padding: 0 1em;
  max-width: 30em;
  line-height: 1.6;
`;


export default Tos;



// WEBPACK FOOTER //
// ./src/pages/tos.js